import type { Module } from 'vuex';
import { Blockchain } from '@/types/Blockchain';
import {RootState} from "@/store";

export interface BlockchainsState {
  blockchains: Blockchain[];
}

const blockchainsModule: Module<BlockchainsState, RootState> = {
  namespaced: true,

  state: (): BlockchainsState => ({
    blockchains: [],
  }),

  getters: {
    getById: (state) => (idBlockchain: number): Blockchain | undefined => {
      return state.blockchains.find(blockchain => blockchain.idBlockchain === idBlockchain);
    },
  },

  mutations: {
    setBlockchains(
      state,
      payload: { blockchains: Record<number, any> }
    ) {
      state.blockchains = Object
        .values(payload.blockchains)
        .map(Blockchain.fromRaw);
    },

    setBlockchainCreate(
      state,
      payload: {
        idBlockchain: number;
        name: string;
        preg: string;
        tag: boolean;
        decimalPlace: number;
        locked: boolean;
      }
    ) {
      const raw = {
        idBlockchain: payload.idBlockchain,
        name: payload.name,
        preg: payload.preg,
        tag: payload.tag,
        decimalPlace: payload.decimalPlace,
        locked: payload.locked,
      };
      state.blockchains.push(Blockchain.fromRaw(raw));
    },

    setBlockchainUpdate(
      state,
      payload: {
        idBlockchain: number;
        name?: string;
        preg?: string;
        tag?: boolean;
        decimalPlace?: number;
        locked?: boolean;
      }
    ) {
      const blockchain = state.blockchains.find(blockchain => blockchain.idBlockchain === payload.idBlockchain);
      if (!blockchain) return;
      if (payload.name   !== undefined) blockchain.name   = payload.name;
      if (payload.preg   !== undefined) blockchain.preg   = payload.preg;
      if (payload.tag    !== undefined) blockchain.tag    = payload.tag;
      if (payload.decimalPlace !== undefined) blockchain.decimalPlace = payload.decimalPlace;
      if (payload.locked !== undefined) blockchain.locked = payload.locked;
    },

    setBlockchainDelete(
      state,
      payload: { idBlockchain: number }
    ) {
      state.blockchains = state.blockchains.filter(
        blockchain => blockchain.idBlockchain !== payload.idBlockchain
      );
    },

    setBlockchainLock(
      state,
      payload: { idBlockchain: number }
    ) {
      const blockchain = state.blockchains.find(blockchain => blockchain.idBlockchain === payload.idBlockchain);
      if (blockchain) blockchain.locked = true;
    },

    setBlockchainUnlock(
      state,
      payload: { idBlockchain: number }
    ) {
      const blockchain = state.blockchains.find(blockchain => blockchain.idBlockchain === payload.idBlockchain);
      if (blockchain) blockchain.locked = false;
    },
  },

  actions: {
    wsSetBlockchains({ commit }, payload) {
      commit('setBlockchains', payload);
    },
    wsBlockchainCreate({ commit }, payload) {
      commit('setBlockchainCreate', payload);
    },
    wsBlockchainUpdate({ commit }, payload) {
      commit('setBlockchainUpdate', payload);
    },
    wsBlockchainDelete({ commit }, payload) {
      commit('setBlockchainDelete', payload);
    },
    wsBlockchainLock({ commit }, payload) {
      commit('setBlockchainLock', payload);
    },
    wsBlockchainUnlock({ commit }, payload) {
      commit('setBlockchainUnlock', payload);
    },
  },
};

export default blockchainsModule;
